<template>
  <div class="activate tc">
    <p class="remind">A verification email has been sent to your inbox.</p>
    <p class="remind">You will need to  click the activition link to complete the registration.</p>
    <p class="remind">If you do not receive your email within a few minutes, please try these options:</p>
    <ol class="options">
      <li class="options-item tl">Check your other folders, including spam and junk folder</li>
      <li class="options-item tl">Click the Resend Email to resend the email again</li>
    </ol>
    <p class="resend"><a href="javascript:void(0)" class="link" @click='resendEmail'>Resend Email</a></p>
  </div>
</template>

<script>
import userService from '../service/userService';
import loading from "../../common/utils/loading";

export default {
  data() {
    return {
      is_loading: false,
    }
  },

  mounted() {
  },

  methods: {
    resendEmail:function(){
      if (this.is_loading) return;
      this.is_loading = true;
      loading.show()
      userService.activateEmailResend()
      .then(res => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(()=>{
        this.is_loading = false;
        loading.hide()
      })
    },
  }
}
</script>

<style></style>
